<template>
  <div class="mb-3">
    <StarRating :selectable="true"
                :rating="object.rating"
                @ratingChosen="ratingChosen"
                :show-rating-number="false"/>
  </div>
</template>

<script setup>
import StarRating from "@/components/parts/staff/StarRating.vue"

const props = defineProps({
  object: {
    type: Object
  },
})

const ratingChosen = (val) => {
  props.object.rating = val
}
</script>
